/* Shared utilities for the v2 mockup proposals.
   Caricamento dei font Google in modo idempotente: non altera index.html. */

import { useEffect } from 'react';

const FONTS_HREF =
  'https://fonts.googleapis.com/css2?' +
  [
    'family=Cabinet+Grotesk:wght@500;700;900',
    'family=IBM+Plex+Sans:wght@400;500;600',
    'family=IBM+Plex+Mono:wght@400;500',
    'family=Cormorant+Garamond:wght@500;600;700',
    'family=Outfit:wght@400;500;600;700',
    'family=Manrope:wght@400;500;600;700;800',
    'family=JetBrains+Mono:wght@400;500',
    'family=Space+Grotesk:wght@500;700',
    'family=Playfair+Display:wght@500;700',
    'display=swap',
  ].join('&');

export const useV2Fonts = () => {
  useEffect(() => {
    const id = 'mockup-v2-fonts';
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = FONTS_HREF;
    document.head.appendChild(link);
  }, []);
};

// Mock data condiviso fra le 3 proposte: stessi numeri, stesso contenuto,
// così l'utente confronta SOLO l'estetica.
export const MOCK = {
  hotelName: 'Hotel Galleria',
  user: 'Laura Bianchi',
  kpis: {
    open: 45,
    avgResolution: '2.4h',
    sla: '98%',
    critical: 7,
  },
  urgent: [
    { id: '#3412', title: 'Climatizzatore in tilt', room: '405', priority: 'urgente', age: '12m' },
    { id: '#3408', title: 'Perdita lavandino lobby', room: 'Hall', priority: 'alta', age: '48m' },
    { id: '#3401', title: 'Ascensore B fermo piano 4', room: 'Asc-B', priority: 'urgente', age: '1h 12m' },
    { id: '#3389', title: 'TV non accende', room: '208', priority: 'media', age: '2h 30m' },
    { id: '#3382', title: 'Frigobar non raffredda', room: '317', priority: 'media', age: '3h 05m' },
  ],
  technicians: [
    { name: 'Mario Rossi', open: 7, today: 4 },
    { name: 'Luca Bianchi', open: 5, today: 3 },
    { name: 'Davide Conti', open: 4, today: 2 },
    { name: 'Andrea Costa', open: 3, today: 2 },
  ],
  consumption: {
    kwhPerRoom: 32.4,
    waterPerRoom: 0.81,
    smcPerRoom: 4.6,
    efficiency: 67,
    trend12m: [55, 58, 61, 59, 60, 62, 65, 64, 66, 67, 67, 67],
  },
  hotels: [
    { name: 'Galleria', open: 12, eff: 67 },
    { name: 'Arcimboldi', open: 9, eff: 71 },
    { name: 'Manzoni', open: 14, eff: 58 },
    { name: 'Kira (All-Electric)', open: 10, eff: 63 },
  ],
};
